import { booleanAttribute, Directive, Input } from '@angular/core';

@Directive({
    selector: 'nova-grid-toggle',
    standalone: true
})
export class GridToggleDirective {
    @Input() field!: string;
    @Input() label = '';
    @Input() value: any;
    @Input({ transform: booleanAttribute }) checked = false;
    @Input({ transform: booleanAttribute }) disabled = false;
    @Input() matTooltip = '';
}
